import { Component, Input } from '@angular/core';

@Component({
  selector: 'mojo-number-presenter-v2',
  templateUrl: './number-presenter-v2.component.html',
  styleUrls: ['./number-presenter-v2.component.scss']
})
export class NumberPresenterV2Component {
  @Input() number;
  @Input() label;
  @Input() mainNumber = false;
  @Input() clickable = true;
}
